import { NOTIFICATION_LIST_COLUMN } from "./actionTypes";

export const setNotificationListColumn = (field, value) => ({
  type: NOTIFICATION_LIST_COLUMN,
  payload: { field, value },
});
